import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { PropertyDiscountRulValidation } from 'uplisting-frontend/validations';

export default class PropertyDiscountRuleRepositoryService extends BaseRepositoryService<
  ModelRegistry['property-discount-rule']
> {
  recordName = 'property-discount-rule';
  implementMethods = ['buildChangeset'];

  validation = PropertyDiscountRulValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/property-discount-rule': PropertyDiscountRuleRepositoryService;
  }
}
